import { useMemo, useRef, useEffect } from 'react';
import gsap from 'gsap';

//* Style
import OurCultureStyle from './style';

//* Helpers
import { useActiveSection } from '@/helpers';

//* Components
import Image from '@/components/common/Image';
import Container from '@/components/common/Container';
import Text from '@/components/common/Text';

const OurCulture = ({ title, rows }) => {
	//! Refs
	const sectionRef = useRef();
	const cultureItems = useRef([]);

	const activeSection = useActiveSection(sectionRef, 80);

	useEffect(() => {
		if (activeSection) {
			gsap.to([cultureItems.current], { y: 0, stagger: 0.01 });
		}
	}, [activeSection]);

	//! Culture items
	const storeOurCultureItems = useMemo(() => {
		return rows.map((item, index) => (
			<div
				ref={(ref) => (cultureItems.current[index] = ref)}
				className='item-col'
				key={index}>
				<Image
					className={'item-image'}
					src={item.image.src}
					alt={item.image.alt}
				/>
				<Text
					className={'h2 font-futura-medium item-title'}
					text={item.title}
				/>
				<Text
					className={'h5 font-futura-regular item-description'}
					text={item.description}
				/>
			</div>
		));
	}, [rows]);

	return (
		<OurCultureStyle ref={sectionRef}>
			<Container
				section
				className={'culture-container'}>
				<Container
					full
					className='culture-items-wrap col-6 col-ts-8'>
					{storeOurCultureItems}
				</Container>
				<div className='item-col-right col-2 col-ts-8 item-col'>
					<Text
						className={'h1 font-futura-medium culture-title'}
						text={title}
					/>
				</div>
			</Container>
		</OurCultureStyle>
	);
};

export default OurCulture;
